import React from "react";
import { Container } from "semantic-ui-react";
import Title from "./Title";
import Invitation from "./Invitation";
import HowIsItWork from "./HowIsItWork";
import Help from "./Help";
import StartSell from "./StartSell";

const HomePageDesigners = () => {
  return (
    <div>
      <Title />
      <Invitation />
      <Container>
        <HowIsItWork />
        {/* <Testmonials/> */}
        <Help />
      </Container>
      <StartSell />
    </div>
  );
};

export default HomePageDesigners;
